import { render } from "./ChartResult.vue?vue&type=template&id=204b1f96&scoped=true"
import script from "./ChartResult.vue?vue&type=script&lang=js"
export * from "./ChartResult.vue?vue&type=script&lang=js"

import "./ChartResult.vue?vue&type=style&index=0&id=204b1f96&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204b1f96"]])

export default __exports__